/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { AppBar, Toolbar } from '@mui/material';
import React from 'react';

import { Colors } from 'src/common/ui/base';
import { NavDrawer } from 'src/components/app/Nav/Nav.Drawer';
import { NavIcons } from 'src/components/app/Nav/Nav.Icons';
import { NavLogo } from 'src/components/app/Nav/Nav.Logo';
import { NavSearch } from 'src/components/app/Nav/Nav.Search';

const isEnvQA = process.env.REACT_APP_ENVIRONMENT === 'qa';

export const NAV_HEIGHT = 64;

export const Nav = () => (
  <AppBar
    data-testid="nav"
    css={css`
      background-color: ${isEnvQA ? Colors.Peach6 : Colors.Blue5};
      height: ${NAV_HEIGHT}px;

      @media print {
        display: none;
      }
    `}
    position="fixed"
  >
    <Toolbar
      css={css`
        @media print {
          display: none;
        }
      `}
    >
      <NavDrawer />
      <NavLogo />
      <NavSearch />
      <NavIcons />
    </Toolbar>
  </AppBar>
);
